export const formatOtherRecurringBills = (otherRecurringBills) => {
  let str = "";
  let otherRecurringBills_str = [];
  let amount = "0";
  for(let otherRecurringBill of otherRecurringBills){
    if(otherRecurringBill.bill.length > 0 && parseFloat(otherRecurringBill.amount) >= 0){
      amount = otherRecurringBill.amount || amount;
      otherRecurringBills_str.push(`{ bill: "${otherRecurringBill.bill}", amount: ${otherRecurringBill.amount} }`);
    }
  }
  if(otherRecurringBills_str.length > 0){
    str = otherRecurringBills_str.join(",")
  }
  return str;
}

/* user is hardcoded now but will not be hardcoded in future as it
will be passed as props to the OnboardingSteps component*/
export const AddPropertyMutation = (propertyName, numUnits, city, address, waterRate, electricityRate,
  mpesaShortcode, mpesaShortcodeType, tillNumber, penaltyType, fixedPenaltyAmount, percentagePenaltyAmount,
  automaticallyPenalize, penaltyDayOfMonth, managementFeeType, managementFeeFixedAmount, managementFeePercentage,
  taxRate, otherRecurringBills=[], notes, companyName, paymentInstructions, managementInvoices
) => {
    const mutation = `
    mutation{
        addProperty(
            name:"${propertyName}",
            unitCount: ${numUnits},
            city: "${city}",
            addressStreet: "${address}",
            waterRate: ${waterRate},
            electricityRate: ${electricityRate},
            mpesaShortcode: "${mpesaShortcode}",
            mpesaShortcodeType: "${mpesaShortcodeType}",
            tillNumber: "${tillNumber}",
            penaltyType: "${penaltyType}",
            fixedPenaltyAmount: ${fixedPenaltyAmount},
            percentagePenaltyAmount: ${percentagePenaltyAmount},
            automaticallyPenalize: ${automaticallyPenalize},
            penaltyDayOfMonth: ${penaltyDayOfMonth},
            managementFeeType: "${managementFeeType}",
            managementFeeFixedAmount: ${managementFeeFixedAmount},
            managementFeePercentage: ${managementFeePercentage},
            taxRate: ${taxRate},
            otherRecurringBills: [${formatOtherRecurringBills(otherRecurringBills)}],
            notes: ${JSON.stringify(notes)}
            companyName: ${JSON.stringify(companyName)}
            paymentInstructions: ${JSON.stringify(paymentInstructions)}
            managementInvoices: ${JSON.stringify(managementInvoices)}
            ){
                property{
                  id,
                  name,
                  unitCount,
                  city,
                  addressStreet,
                  waterRate,
                  electricityRate,
                  mpesaShortcode{
                    shortcode
                    shortcodeType
                    tillNumber
                  },
                  propertyPenaltyType,
                  fixedPenaltyAmount,
                  percentagePenaltyAmount,
                  automaticallyPenalize,
                  penaltyDayOfMonth,
                  managementFeeType,
                  managementFeeFixedAmount,
                  managementFeePercentage,
                  taxRate,
                  otherRecurringBills,
                  notes
                  companyName
                  paymentInstructions
                  managementInvoices
                }
            }
      }
    `;
    return mutation;
}

/*Query to get property associated with a certain user
userID is hardcoded but will later on be passed using props */
export const GetPropertiesQuery = () =>{
    const query = `
    query{
      userProperties{
        id,
        name,
        unitCount,
        city,
        addressStreet,
        vacancies,
        waterRate,
        electricityRate,
        mpesaShortcode{
          id
          shortcode
          uniqueId
          shortcodeType
          tillNumber
        },
        propertyPenaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        managementFeeType,
        managementFeeFixedAmount,
        managementFeePercentage,
        taxRate,
        otherRecurringBills,
        notes
        companyName
        paymentInstructions
        managementInvoices
      }
    }
    `;
    return query;
}



//Mutation to update/edit property details
export const UpdatePropertyMutation = (propertyID, propertyName, numUnits, city,
  addressStreet, waterRate, electricityRate, mpesaShortcode, mpesaShortcodeType, tillNumber,
  penaltyType, fixedPenaltyAmount, percentagePenaltyAmount, automaticallyPenalize, penaltyDayOfMonth,
  managementFeeType, managementFeeFixedAmount, managementFeePercentage, taxRate, otherRecurringBills=[],
  notes, companyName, paymentInstructions, managementInvoices
  ) => {
    const mutation = `
    mutation{
      updateProperty(
        id:${JSON.stringify(propertyID)}, name:"${propertyName}", unitCount:${numUnits}, city:"${city}",
        addressStreet:"${addressStreet}", waterRate: ${waterRate}, electricityRate: ${electricityRate},
        mpesaShortcode: "${mpesaShortcode}", mpesaShortcodeType: "${mpesaShortcodeType}",
        tillNumber: "${tillNumber}",penaltyType: "${penaltyType}", fixedPenaltyAmount: ${fixedPenaltyAmount},
        percentagePenaltyAmount: ${percentagePenaltyAmount}, automaticallyPenalize: ${automaticallyPenalize},
        penaltyDayOfMonth: ${penaltyDayOfMonth}, managementFeeType: "${managementFeeType}",
        managementFeeFixedAmount: ${managementFeeFixedAmount}, managementFeePercentage: ${managementFeePercentage},
        taxRate: ${taxRate},
        otherRecurringBills: [${formatOtherRecurringBills(otherRecurringBills)}],
        notes:${JSON.stringify(notes)},
        companyName: ${JSON.stringify(companyName)},
        paymentInstructions: ${JSON.stringify(paymentInstructions)}
        managementInvoices: ${JSON.stringify(managementInvoices)}
      ){
        property{
          id,
          name,
          city,
          addressStreet,
          unitCount,
          waterRate,
          electricityRate,
          mpesaShortcode{
            shortcode
            shortcodeType
            tillNumber
          }
          propertyPenaltyType,
          fixedPenaltyAmount,
          percentagePenaltyAmount,
          automaticallyPenalize,
          penaltyDayOfMonth,
          managementFeeType,
          managementFeeFixedAmount,
          managementFeePercentage,
          taxRate,
          otherRecurringBills,
          notes
          companyName
          paymentInstructions
          managementInvoices
        }
      }
    }
    `;
    return mutation;
}

// Mutation to delete property
//Remember to send request with token
export const DeletePropertyMutation = (propertyID) => {
  const mutation = `
  mutation{
    deleteProperty(id:${JSON.stringify(propertyID)}){
      success
    }
  }
  `;
  return mutation;
}

// Getting all properties, units and tenants using one request
export const GetAllPropertiesUnitsTenants = () => {
  const query = `
  query{
    allPropertyUnitsTenantsData{
      properties{
        id,
        name,
        unitCount,
        city,
        addressStreet,
        vacancies,
        waterRate,
        electricityRate
        mpesaShortcode{
          shortcode
          shortcodeType
          tillNumber
        }
        propertyPenaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        managementFeeType,
        managementFeeFixedAmount,
        managementFeePercentage,
        taxRate,
        otherRecurringBills,
        notes
        companyName
        paymentInstructions
        managementInvoices
      }
      units{
        property{
          id
        },
        id,
        unitName,
        rentAmount,
        occupied,
        taxRate,
        otherRecurringBills,
        notes
      }
    }
  }
  `;
  return query;
}